import React from "react";
import { Box, Button, Collapse, Stack, Typography } from "@mui/material";

const ScoreBreakdown = ({ components = {}, expanded, onToggle }) => {
  const entries = Object.entries(components);

  if (entries.length === 0) return null;

  return (
    <Box>
      <Button
        aria-expanded={expanded}
        onClick={onToggle}
        size="small"
        variant="text"
      >
        {expanded ? "Hide score breakdown" : "Show score breakdown"}
      </Button>
      <Collapse in={expanded}>
        <Stack component="dl" spacing={0.5} sx={{ m: 0, pt: 1 }}>
          {entries.map(([name, value]) => (
            <Stack
              component="div"
              direction="row"
              justifyContent="space-between"
              key={name}
            >
              <Typography component="dt" variant="body2">
                {name}
              </Typography>
              <Typography component="dd" variant="body2" sx={{ m: 0 }}>
                {value}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};

export default ScoreBreakdown;
